// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth"; // ✅ ADD THIS

const firebaseConfig = {
  apiKey: "AIzaSyBhaJYNfPs6wHSXbEMOP2TYwTgaJ-ZSxEs",
  authDomain: "dvvprojects-84dc7.firebaseapp.com",
  projectId: "dvvprojects-84dc7",
  storageBucket: "dvvprojects-84dc7.firebasestorage.app",
  messagingSenderId: "917231327102",
  appId: "1:917231327102:web:57e49864d5703f9bacc52f",
  measurementId: "G-SLDP8KPSWL",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore DB
export const db = getFirestore(app);

// Firebase Storage
export const storage = getStorage(app);

// Firebase Auth
export const auth = getAuth(app);
